export enum Claim {
    UserId = 'api.awaretrain.userid',
    UserName = 'api.awaretrain.userName',
    Roles = 'api.awaretrain.role',
    Rights = 'api.awaretrain.right'
}
